<template>
  <div class="categories-panel">
    <div class="flex bg-smoke-100 px-4 py-4 shadow-lg lg:shadow-none overflow-auto max-h-75vh lg:max-h-108">
      <div
        v-for="(cat, index) in getCategories"
        :key="`panel-category-${index}`"
        class="px-4 whitespace-nowrap"
      >
        <router-link
          class="font-semibold hover:text-green text-sm"
          :to="`/${cat.slug}`"
        >{{cat.name}}</router-link>
        <div
          v-for="(sub, subIndex) in cat.subCategories"
          :key="`${index}-panel-sub-category-${subIndex}`"
          class="leading-4"
        >
          <router-link
            class="inline-block pt-1 hover:text-green text-xs"
            :to="`/${sub.slug}`"
          >
            {{ sub.name }}
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  name: 'CategoriesPanel',
  computed: { ...mapGetters ([ 'getCategories' ]) }
}
</script>
<style lang="scss" scoped>
  .categories-panel {
    @apply px-5 pt-2 absolute z-10 w-full overflow-hidden duration-200 transition-transform ease-in-out;
    @screen lg { @apply px-0 pt-0; }
    transform-origin: top;
    /* width */
    /deep/::-webkit-scrollbar {
      width: 10px;
      height: 10px;
    }

    /* Track */
    /deep/::-webkit-scrollbar-track {
      background: rgba(35, 31, 32, 0.15);
    }

    /* Handle */
    /deep/::-webkit-scrollbar-thumb {
      background: #29B574;
      border-radius: 10px;
    }
  }
</style>
